import styled, { css } from 'styled-components';
import { devices } from 'styles/devices';
import { colors } from 'styles/colors';

const Button = styled.button`
   position: relative;
   display: block;
   height: 40px;
   line-height: 40px;
   font-size: 14px;
   font-weight: 600;
   padding: 0 44px 0 30px;
   background: ${colors.primary};
   border: none;
   color: ${colors.white};
   border-radius: 20px;
   text-decoration: none;
   transition: transform 0.35s ease-in-out;
   letter-spacing: -0.02em;
   flex-shrink: 0;

   ${({ reverse }) =>
      reverse &&
      css`
         padding: 0 14px 0 24px;

         ${devices.mobile} {
            padding: 0 30px 0 44px;
         }
      `}

   &:focus {
      outline: 0;
      background: ${colors.primary20};
   }

   &::before,
   &::after {
      content: '';
      position: absolute;
      top: 50%;
      border: solid ${colors.white};
      border-width: 0 2px 2px 0;
      width: 6px;
      height: 6px;

      ${devices.mobile} {
         width: 8px;
         height: 8px;
      }
   }

   &::before {
      left: 20px;
      top: 50%;
      transform: translateY(-50%) rotate(135deg);
      display: ${({ reverse }) => (reverse ? 'block' : 'none')};
   }

   &::after {
      right: 20px;
      display: ${({ reverse }) => (reverse ? 'none' : 'block')};
      transform: rotate(-45deg) translateY(-50%);
   }

   &:hover {
      text-decoration: none;
      color: ${colors.white};
      transform: scale(0.97);
   }
`;

export default Button;
